module.exports = __webpack_public_path__ + "static/media/square.904cafdb.png";